import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { OpHubMember } from '@/modules/__generated__/graphql/switchboard-generated';
import { InternalLink } from '@/modules/shared/components/internal-link';
import ff from '@/modules/shared/lib/feature-flags';
import type { Route } from 'next';
interface ProfileFinancesCardContentProps {
  builderSlug: string;
  operationalHub: OpHubMember;
}
function ProfileFinancesCardContent(t0) {
  const $ = _c(15);
  const {
    builderSlug,
    operationalHub
  } = t0;
  const operationalHubName = operationalHub.name ?? "";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-foreground/50 text-sm/4.5 font-semibold">View all expenses of the Powerhouse Ecosystem Actor.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `/network/powerhouse/builders/${builderSlug}/budget-statements` as Route;
  let t3;
  if ($[1] !== t2) {
    t3 = <InternalLink href={t2}>Budget Statements</InternalLink>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ff.builders.FINANCES_LINK_ENABLED && <InternalLink href={"/network/powerhouse/finances" as Route}>Finances</InternalLink>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className="flex gap-4">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-card text-foreground/30 absolute -top-2.5 left-2 px-2 text-sm/4.5 font-medium">Operational Hub</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = !operationalHubName && "text-foreground/50";
  let t8;
  if ($[7] !== t7) {
    t8 = cn("text-foreground text-md/6 font-semibold", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = operationalHubName || "No Operational Hub";
  let t10;
  if ($[9] !== t8 || $[10] !== t9) {
    t10 = <div className="bg-background relative mt-2 flex flex-wrap gap-6 rounded-lg border p-4">{t6}<span className={t8}>{t9}</span></div>;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t5) {
    t11 = <div className="flex flex-col gap-4">{t1}{t5}{t10}</div>;
    $[12] = t10;
    $[13] = t5;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
}
export { ProfileFinancesCardContent };